import Link from 'next/link';

const Body = () => {
  return (
    <section className="site-max relative w-full legales pt-160 sm:pt-240 pb-115">
      <svg
        className="w-[87.8rem] h-auto absolute top-0 left-0"
        viewBox="0 0 878 1881"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M64.9442 332.007C64.9442 232.044 141.375 128 241.201 128L633.972 120.653C652.785 120.653 671.471 118.146 688.794 110.799C724.198 95.7841 800.816 62.1384 860.733 0M64.9441 1L64.9447 1668.5C64.9447 1778.96 -24.5983 1868.5 -135.055 1868.5H-285.5"
          stroke="#EEEEEE"
          strokeOpacity="0.5"
          strokeWidth="24"
          strokeMiterlimit="10"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>

      <div className="site-grid">
        <div className="sm:col-start-2 col-span-4 sm:col-span-10">
          <div className="mb-70">
            <h3 className="title-3 text-cyan-dark">Politicas de Privacidad</h3>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Esta política de privacidad es efectiva desde: 01/12/2017.
            </p>
          </div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">1. Acerca de nosotros y esta política</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Esta política describe cómo Covedisa (en adelante, “Covedisa”) recopila, usa, procesa
              y comparte la información que recoge sobre los Usuarios de la Aplicación.
              <br />
              <br />
              Esta política se aplica a la Aplicación, ya sea que los usuarios la utilicen desde un
              dispositivo móvil, computadora personal o en cualquier otro dispositivo. Puede que
              algunos de los sitios web de terceros que trabajen con y/o emplee Covedisa, como el de
              los e-commerce, tengan políticas de privacidad distintas en relación con cualquier
              información recopilada mediante esos sitios. Las políticas de privacidad aplicables a
              esos sitios estarán disponibles en esos mismos sitios y son responsabilidad exclusiva
              de cada uno de ellos, por lo que Covedisa no es ni puede ser responsable de ninguno de
              ellos.
              <br />
              <br />
              Covedisa es el administrador de datos de la información recopilada bajo esta política
              y se encuentra debidamente registrada por ante la Dirección Nacional de Protección de
              Datos Personales.
              <br />
              <br />
              Al descargar, acceder o hacer uso de la Aplicación, los usuarios acceden a que su
              información se use de acuerdo con esta política de privacidad.
              <br />
              <br />
              Tal como se estipula en las condiciones de la Aplicación, para acceder a ella o
              utilizarla usted debe tener como mínimo 18 años. Covedisa no recoge, ni utiliza
              intencionadamente datos personales de personas menores de 18 años.
            </p>
          </div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">2. Qué tipo de información recopilamos</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Covedisa recopila información de diversas fuentes, pero la gran mayoría proviene
              directamente de los Usuarios de la Aplicación cuando acceden o utilizan la misma. Por
              lo general, la información que se recopila está relacionada con el servicio a brindar
              por cada uno de los Usuarios a través de la Aplicación. La información puede incluir
              datos que cada usuario envía al crear una cuenta dentro de la Aplicación.
            </p>
          </div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">3. Crear un perfil </h6>
          </div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">El perfil</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Para el uso de la Aplicación, Covedisa le brindará un perfil para el acceso a la
              Aplicación que asociaremos con cada Usuario y con su cuenta de correo electrónico. Los
              Usuarios podrán asociar su cuenta a varios dispositivos.
              <br />
              <br />
              El perfil de cada usuario sólo será visible para Covedisa con la finalidad de hacer el
              seguimiento del servicio brindado y relacionado con cada Usuario y/o sus Usuarios
              asociados.
            </p>
          </div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">
              4. ¿Cómo usamos la información que tenemos sobre usted?
            </h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              La información recopilada a través del uso o acceso a la Aplicación es usada por
              Covedisa para analizar la viabilidad de su servicio de entrega en relación con cada
              Usuario. Asimismo, puede que haya otros motivos por los cuales Covedisa necesita usar
              dicha información, como mantener registros o proteger sus derechos legales.
            </p>
          </div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">Atención al Usuario</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Covedisa emplea su información, incluidos los datos que nos facilita directamente en
              comunicaciones, para ofrecer ayuda a los Usuarios cuando la necesiten mediante los
              canales de atención al Usuario de Covedisa. También emplea la información para ponerse
              en contacto con los Usuarios, por ejemplo, como parte de nuestro servicio de atención
              o para enviarle actualizaciones sobre la Aplicación. Por último, Covedisa usa sus
              datos para administrar su cuenta, la relación que tiene con la misma y con Covedisa y
              para mejorar su experiencia al usar la Aplicación y/o proveer los servicios.
            </p>
          </div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">Almacenamiento de Información</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Covedisa puede utilizar en la Aplicación cookies o algún otro tipo de tecnología
              similar para almacenamiento de datos. Estas tecnologías recopilan y almacenan ciertos
              datos en el dispositivo utilizado para el acceso y uso de la Aplicación o accediendo a
              datos del mismo dispositivo. Permiten, además, la recopilación de datos como el modelo
              de los dispositivos utilizados, el sistema operativo, etc.
            </p>
          </div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">
              6. ¿Quién más puede ver su información?
            </h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Puede que compartamos su información con los clientes y/o proveedores de nuestros
              servicios si es necesario para el funcionamiento de la Aplicación y/o el negocio de
              Covedisa. No obstante, y en principio, Covedisa no comparte ni compartirá con terceros
              la información y los datos recopilados en la Aplicación, en relación a los Usuarios
              (sean estas Cuentas Principales o Cuentas Asociadas).
            </p>
          </div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">
              7. Derechos del Usuario en relación con su información
            </h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Los Usuarios tienen ciertos derechos sobre su información personal y la manera en que
              la usamos, conforme la Ley 25.326 y su legislación reglamentaria.
              <br />
              <br />
              Estos derechos incluyen:
            </p>
          </div>
          <div className="mb-32">
            <ul className="p1 text-grey-dark list-disc pl-20">
              <li className="mb-10">
                <span className="font-semibold">Derecho de información:</span> los Usuarios pueden
                solicitar información al organismo de control relativa a la existencia de archivos,
                registros, bases o bancos de datos personales, sus finalidades y la identidad de sus
                responsables.
              </li>
              <li className="mb-10">
                <span className="font-semibold">Derecho de acceso:</span> el titular de los datos
                personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma
                gratuita a intervalos no inferiores a seis (6) meses, salvo que se acredite un
                interés legítimo al efecto, conforme lo establecido en el art. 14, inc. 3 de la Ley
                25.326. Conforme Art 1 de la Disposición 10/2008.
              </li>
              <li className="mb-10">
                <span className="font-semibold">
                  Derecho a corregir información personal (actualización o rectificación):
                </span>
                Covedisa intenta que la información que tiene sobre los Usuarios sea correcta y esté
                actualizada. En el caso de que los Usuarios descubrieran que alguno de los datos que
                tiene es incorrecto, debe ponerse en contacto con &nbsp;
                <Link href="mailto:soporte@hopenvios.com.ar" className="underline">
                  soporte@hopenvios.com.ar
                </Link>
                &nbsp; indicando el dato y el error para que Covedisa lo analice y lo corrija a la
                mayor brevedad posible, en caso de corresponder.
              </li>
              <li className="mb-10">
                <span className="font-semibold">Supresión de datos.</span> En algunas
                circunstancias, los Usuarios tienen el derecho a pedir que se eliminen algunos y/o
                todos los datos personales. Para tal finalidad, debe ponerse en contacto con
                Covedisa a &nbsp;
                <Link href="mailto:soporte@hopenvios.com.ar" className="underline">
                  soporte@hopenvios.com.ar.
                </Link>
                &nbsp; Los Usuarios deben tener presente que la supresión parcial y/o total no
                procederá en caso que la misma pueda causar perjuicios a los derechos o intereses
                legítimos de terceros o cuando existiera una obligación legal de conservar los
                mismo. En este último caso Covedisa hará sus mejores esfuerzos para evitar su
                divulgación, corrupción y/o daños
              </li>
              <li className="mb-10">
                <span className="font-semibold">Confidencialidad de datos:</span> los Usuarios
                pueden requerir a &nbsp;
                <Link href="mailto:soporte@hopenvios.com.ar" className="underline">
                  soporte@hopenvios.com.ar.
                </Link>
                &nbsp; que los datos que Covedisa conserve de ellos sean tratados confidencialmente.
                Covedisa atenderá a dichos pedidos y procederá conforme, en la mayor medida que lo
                permita la legislación y siempre y cuando no afecte derechos e intereses legítimos
                de terceros o no se encuentre en juego una obligación legal de mantener dichos datos
                públicos.
              </li>
              <li className="mb-10">
                <span className="font-semibold">Desactivación de la cuenta.</span> Los Usuarios
                pueden solicitar a Covedisa la desactivación de la misma. Para ellos, los Usuarios
                deben tener en cuenta que si solicitan la desactivación de su cuenta por completo,
                perderán todo dato asociado a la misma y no se podrán recuperar en el futuro.
                Asimismo y conforme se enunció en los términos de uso, Covedisa puede desactivar las
                cuentas de los Usuarios o suspenderlas, frente al caso de uso ilegal o contrario a
                dichos términos o a esta política de privacidad.
              </li>
            </ul>
          </div>
          <div className="w-full h-1 bg-grey mb-32"></div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">
              8. ¿Cuánto tiempo conservamos su información y dónde la almacenamos?
            </h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Covedisa conservará su información el tiempo que crea necesario para los fines del
              negocio y la actividad de Covedisa, en función de la legislación vigente.
            </p>
          </div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">9. Cambios en la política</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Puede que la política de privacidad sea modificada de tanto en tanto. Covedisa
              publicará el contenido actualizado de la política de privacidad en esta página. Los
              usuarios deberán visitar esta página de vez en cuando para asegurarse de que conoce la
              última versión. La política nueva será efectiva a partir de la fecha en la que la
              publiquemos.
            </p>
          </div>
          <div className="mb-12">
            <h6 className="title-6 text-cyan-dark mb-12">10. Contacto</h6>
          </div>
          <div className="mb-32">
            <p className="p1 text-grey-dark">
              Si los usuarios desean contactarse con Covedisa sobre cualquiera de los puntos
              relacionados con esta política de privacidad, incluido el ejercicio de sus derechos,
              deberán dirigirse a nuestro departamento de atención mediante un correo electrónico a
              &nbsp;
              <Link href="mailto:soporte@hopenvios.com.ar" className="underline">
                soporte@hopenvios.com.ar.
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Body;
